import { writable } from 'svelte/store';
export const PRODUCT_STORE = writable({});
export const PRODUCT_LIST_STORE = writable([]);
